import type { KeyboardEvent } from "react";
import type { Brand } from "../types/marketplace";

interface BrandCardProps {
  brand: Brand;
  onSelect?: (brand: Brand) => void;
}

function BrandCard({ brand, onSelect }: BrandCardProps) {
  const handleSelect = () => {
    onSelect?.(brand);
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLElement>) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleSelect();
    }
  };

  return (
    <article
      className={`brand-card ${onSelect ? "clickable" : ""}`}
      onClick={handleSelect}
      onKeyDown={onSelect ? handleKeyDown : undefined}
      role={onSelect ? "button" : undefined}
      tabIndex={onSelect ? 0 : undefined}
    >
      <span style={{ backgroundColor: brand.color }}>
        {brand.logo ? (
          <img src={brand.logo} alt={brand.name} decoding="async" loading="lazy" />
        ) : (
          brand.letter
        )}
      </span>
      <strong>{brand.name}</strong>
      <small>{brand.category}</small>
    </article>
  );
}

export default BrandCard;
